export default __webpack_public_path__ + "static/media/icon-triple-dot.7f5db960.svg";